import { render, staticRenderFns } from "./warnGis.vue?vue&type=template&id=a90b4092&scoped=true"
import script from "./warnGis.vue?vue&type=script&lang=js"
export * from "./warnGis.vue?vue&type=script&lang=js"
import style0 from "./warnGis.vue?vue&type=style&index=0&id=a90b4092&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a90b4092",
  null
  
)

export default component.exports